interface IPageTitleFromPathname {
    eventId: string;
    eventName: string;
    channelName: string;
    momentId: string;

}
export default ({ channelName, eventId, eventName, momentId }: IPageTitleFromPathname) => {
    interface INameMap {
        [key: string]: any;
    }
    let nameMap_ef: INameMap = {};
    nameMap_ef = {
        '/events': 'Events',
        [`/events/${eventId}`]: `${eventName}`,
        [`/events/${eventId}/moments`]: 'Moments',
        [`/events/${eventId}/moments/${momentId}`]: 'Details',
        [`/events/${eventId}/notifications`]: 'Notifications',
        [`/events/${eventId}/notifications/new`]: 'New Notification',
        [`/events/${eventId}/channels/modify`]: `${channelName}`,
        [`/events/${eventId}/channels`]: 'Channels',
        [`/events/${eventId}/channels/new`]: 'Create a channel',
        [`/events/${eventId}/profile`]: 'Profile',
        [`/events/${eventId}/discover`]: 'Discover',
        [`/events/${eventId}/itinerary`]: 'Itinerary',
    };

    return nameMap_ef;
};
